import { render, staticRenderFns } from "./discount-edit.vue?vue&type=template&id=48dda76e&"
import script from "./discount-edit.vue?vue&type=script&lang=js&"
export * from "./discount-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports